import { Injectable } from '@angular/core';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import 'parse';
import { Tchekb, HydratedTchek, PicturesSelectedTchek } from '../model/tchekb.model';

import { DamageService } from './damage.service';
import { environment } from '../../environments/environment';
import { SubscriptionService } from './subscription.service';
import { Observable, Subscriber } from 'rxjs';
import { AwsService } from './aws.service';
import * as $ from 'jquery';
import { promise } from 'protractor';

const parse: typeof Parse = require('parse');

@Injectable()
export class TchekService implements ParseAPIService<Tchekb> {
  store: DbObjectsStore<Tchekb>;
  public unreadCount : number
  constructor(
    private readonly _damageService: DamageService,
    private readonly _subscriptionService: SubscriptionService,
    private readonly awsService: AwsService
  ) {
    this.store = {};
  }


  async newExternalTchek(licence: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let device = 'B9TGfpxLR6'
      let acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
      acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), true);
      parse.Cloud.run('newExternalTchek', {
        immat: licence, acl, deviceId: device
      }).then(response => resolve(response),
        error => reject(error));
    });
  }

  public async getAll(opts?: GetTchekOpts): Promise<any> {
    const query = this.baseQuery();
    query.exists("path")
    if (opts) {
      if (opts.sort === 'latest')
        query.descending('tchekCreatedAt');
      if (opts.sort === 'oldest')
        query.ascending('tchekCreatedAt');
      if (opts.limit)
        query.limit(opts.limit);
      if (opts.skip)
        query.skip(opts.skip);
    }
    try {
      const foundObjects = await query.find();
      let tcheks: (Tchekb | HydratedTchek)[] = foundObjects
        .map(o => new Tchekb(o));

      if (opts && opts.includeThumbnail) {
        tcheks = tcheks.map<HydratedTchek>(t => {
          const baseUrl = `${environment.isLocal ? t.devicePtr.webObjectId : t.devicePtr.id}/${t.path}`;
          var url = environment.thumbnailFilename
          if (t.picturesSelected && t.picturesSelected["thumbnail"]) {
            url = t.picturesSelected["thumbnail"].camera + "/" + t.picturesSelected["thumbnail"].picture + ".jpg";
          } else {
            url = environment.thumbnailFilename;
          }
          if (t instanceof HydratedTchek) {
            return new HydratedTchek(t.getParseInstance(), `${baseUrl}/mini/${url}`);
          } else {
            return new HydratedTchek(t.getParseInstance(), `${baseUrl}/mini/${url}`);
          }

        });
      }

      tcheks.forEach(t => this.store[t.id] = t);
      return tcheks;
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  public async get(id: string, includesCompany?: boolean): Promise<Tchekb> {

    let query;
    if (includesCompany)
      query = this.baseQuery(includesCompany);
    else
      query = this.baseQuery();

    try {
      this.store[id] = new Tchekb(await query.get(id));
      return this.store[id];
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async getDA(id: string, includesCompany?: boolean): Promise<Tchekb> {

    let query;
    if (includesCompany)
      query = new parse.Query('Tchek')
        .include(['devicePtr', 'devicePtr.companyPtr', 'devicePtr.companyPtr.settingsPtr', 'vehiclePtr']);
    else
      query = new parse.Query('Tchek')
        .include(['devicePtr', 'vehiclePtr']);
    try {
      this.store[id] = new Tchekb(await query.get(id));
      return this.store[id];
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async countTcheks(limit?: number): Promise<number> {
    const query = this.baseQuery();
    if (typeof limit === 'number')
      query.limit(limit);
    query.exists("path");
    return await query.count();
  }


  public async countUnread(limit?: number): Promise<number> {
    console.log("DEBUG: countUnread", limit);
    const query = this.baseQuery();
    if (typeof limit === 'number')
      query.limit(limit);
    query.exists("path");
    query.notEqualTo('isDeleted', true);
    query.equalTo('isNew', true);
    return await query.count();
  }

  public subscribeUnreadCount(plusOneHandler: Function,
    minusOneHandler: Function) {
    this._subscriptionService.sub(
      this.baseQuery().equalTo('isNew', true), 'unreadTcheks');
    this._subscriptionService.listen('unreadTcheks', 'create', plusOneHandler);
    this._subscriptionService.listen('unreadTcheks', 'enter', plusOneHandler);
    this._subscriptionService.listen('unreadTcheks', 'leave', minusOneHandler);
    this._subscriptionService.listen('unreadTcheks', 'delete', minusOneHandler);
  }

  public unsubscribeUnreadCount() {
    this._subscriptionService.ignore('unreadTcheks', 'create');
    this._subscriptionService.ignore('unreadTcheks', 'enter');
    this._subscriptionService.ignore('unreadTcheks', 'leave');
    this._subscriptionService.ignore('unreadTcheks', 'delete');
    this._subscriptionService.unsub('unreadTcheks');
  }

  public subscribeTcheks(opts?: GetTchekOpts): TchekObservablesTrio {
    const query = this.baseQuery();
    if (opts) {
      if (opts.sort === 'latest')
        query.descending('tchekCreatedAt');
      if (opts.sort === 'oldest')
        query.ascending('tchekCreatedAt');
      if (opts.limit)
        query.limit(opts.limit);
      if (opts.skip)
        query.skip(opts.skip);
    }

    this._subscriptionService.sub(query, 'tcheks');
    return {
      plusOneObservable: Observable.create((observer: Subscriber<Tchekb>) => {
        this._subscriptionService
          .listen('tcheks', 'create', (newTchek: Parse.Object) => {
            this.hydrateTchek(newTchek, opts)
              .then(tchek => observer.next(tchek));
          });
        this._subscriptionService
          .listen('tcheks', 'enter', (newTchek: Parse.Object) => {
            this.hydrateTchek(newTchek, opts)
              .then(tchek => observer.next(tchek));
          });
      }),
      minusOneObservable: Observable.create((observer: Subscriber<Tchekb>) => {
        this._subscriptionService
          .listen('tcheks', 'leave', (newTchek: Parse.Object) => {
            // ? Hydration step could be removed, if not needed, to enhance performance
            this.hydrateTchek(newTchek, opts)
              .then(tchek => observer.next(tchek));
          });
        this._subscriptionService
          .listen('tcheks', 'delete', (newTchek: Parse.Object) => {
            // ? Hydration step could be removed, if not needed, to enhance performance
            this.hydrateTchek(newTchek, opts)
              .then(tchek => observer.next(tchek));
          });
      }),
      changedObservable: Observable.create((observer: Subscriber<Tchekb>) => {
        this._subscriptionService
          .listen('tcheks', 'update', (newTchek: Parse.Object) => {
            this.hydrateTchek(newTchek, opts)
              .then(tchek => { observer.next(tchek) });
          });
      })
    } as TchekObservablesTrio;
  }

  public async save(tchek: Tchekb | Tchekb[]): Promise<Tchekb | Tchekb[]> {
    if (Array.isArray(tchek)) {
      const array = tchek.map<Parse.Object>(r => r.getParseInstance());
      try {
        const savedObjects = await parse.Object.saveAll(array);
        const damagesFound = [];
        savedObjects.forEach(d => {
          this.store[d.id] = new Tchekb(d);
          damagesFound.push(this.store[d.id]);
        });
        return damagesFound;
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const savedObject = await tchek.getParseInstance().save();
        this.store[savedObject.id] = new Tchekb(savedObject);
        return this.store[savedObject.id];
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async hydrateTchek(tchekOrParseObject: Tchekb | Parse.Object,
    options: GetTchekOpts): Promise<HydratedTchek> {
    let tchek: HydratedTchek;
    if (tchekOrParseObject instanceof Tchekb)
      tchek = new HydratedTchek(tchekOrParseObject.getParseInstance());
    else {
      tchek = new HydratedTchek(tchekOrParseObject);
    }

	//console.log('hydrateTchek', tchek );
	if ([4,5].includes(tchek.type)) return tchek 
    try {
      //      console.log("baseUrl",tchek.picturesSelected)
       const baseUrl = `${environment.isLocal ?
        tchek.devicePtr.webObjectId : tchek.devicePtr.id}/${tchek.path}`;
      if (options && options.includeThumbnail) {
        if (tchek.picturesSelected && tchek.picturesSelected["thumbnail"]) {
          tchek.thumbnailUrl = `${baseUrl}/mini/` + tchek.picturesSelected["thumbnail"].camera + "/" + tchek.picturesSelected["thumbnail"].picture + ".jpg";
        } else {
          tchek.thumbnailUrl = `${baseUrl}/mini/${environment.thumbnailFilename}`;
        }
      }

      if (tchek.immatPicture)
        tchek.immatUrl = `${baseUrl}/mini/immat.jpg`;
 
      return tchek;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async picturesSelectedTchek(tchekOrParseObject: Tchekb | Parse.Object): Promise<PicturesSelectedTchek> {
    let tchek: PicturesSelectedTchek;
    if (tchekOrParseObject instanceof Tchekb)
      tchek = new PicturesSelectedTchek(tchekOrParseObject.getParseInstance());
    else {
      tchek = new PicturesSelectedTchek(tchekOrParseObject);
    }
    let usemini = ''
    if (tchek.uploadHDPictures !== true && environment.isLocal !== true)
      usemini = 'mini/'

    try {
		if (!tchek.devicePtr ) return
      const baseUrl = `${environment.isLocal ? tchek.devicePtr.webObjectId : tchek.devicePtr.id}/${tchek.path}`;
      let allPromise = [];
      ['FL', 'FR', 'BR', 'BL'].forEach(key => {
        if (tchek.picturesSelected && tchek.picturesSelected[key])
          allPromise.push(this.awsService.generateUrlPromise(`${baseUrl}/` + usemini + tchek.picturesSelected[key].camera + "/" + tchek.picturesSelected[key].picture + ".jpg", tchek.devicePtr.ipMachine));
      })
      await Promise.all(allPromise).then(result => {
        tchek.picturesSelectedUrl = result
      })
      return tchek;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async delete(tchek: Tchekb | Tchekb[]): Promise<Tchekb | Tchekb[]> {
    if (Array.isArray(tchek)) {
      const array = tchek.map<Parse.Object>(r => {
        r.isDeleted = true;
        return r.getParseInstance();
      });
      try {
        const deletedObjects = await parse.Object.saveAll(array);
        return deletedObjects.map<Tchekb>(o => new Tchekb(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        tchek.isDeleted = true;
        tchek.toSync = true
        const deletedObject = await tchek.getParseInstance().save();
        return new Tchekb(deletedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async destroy(tchek: Tchekb | Tchekb[]): Promise<Tchekb | Tchekb[]> {
    if (Array.isArray(tchek)) {
      const array = tchek.map<Parse.Object>(r => r.getParseInstance());
      try {
        const destroyedObjects = await parse.Object.destroyAll(array);
        return destroyedObjects.map<Tchekb>(o => new Tchekb(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const destroyedObject = await tchek.getParseInstance().destroy();
        return new Tchekb(destroyedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  private baseQuery(includeCompanySettings?: boolean): Parse.Query {
    if (includeCompanySettings)
      return new parse.Query('Tchek')
        .notEqualTo('isDeleted', true)
        .include(['devicePtr', 'devicePtr.companyPtr', 'devicePtr.companyPtr.settingsPtr', 'vehiclePtr']);
    else
      return new parse.Query('Tchek')
        .notEqualTo('isDeleted', true)
        .include(['devicePtr', 'vehiclePtr']);
  }

}

export interface GetTchekOpts {
  limit?: number;
  skip?: number;
  includeThumbnail?: boolean;
  sort?: 'latest' | 'oldest';
}

export interface TchekObservablesTrio {
  plusOneObservable: Observable<Tchekb>;
  minusOneObservable: Observable<Tchekb>;
  changedObservable: Observable<Tchekb>;
}



// WEBPACK FOOTER //
// ./src/app/service/tchek.service.ts